import {useRef} from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {useDrag, useDrop} from 'react-dnd';
import {FormError, TextArea} from 'shared/components';

const Question = observer(({question, onQuestionDrag, onQuestionDelete, errors = {}}) => {
  const ref = useRef(null);

  const [{isDragging}, connectDrag, connectDragPreview] = useDrag({
    type: 'question',
    item: () => ({index: question.order}),
    collect: monitor => ({isDragging: monitor.isDragging()})
  });

  const [{isOver}, connectDrop] = useDrop({
    accept: 'question',
    collect: monitor => ({isOver: monitor.isOver()}),
    hover(item) {
      const dragIndex = item.index;
      const hoverIndex = question.order;

      if (dragIndex === hoverIndex) return;

      onQuestionDrag(dragIndex, hoverIndex);
      item.index = hoverIndex;
    }
  });

  connectDragPreview(connectDrag(connectDrop(ref)));

  return (
    <div className='col col-12 py2'>
      <div className='h3 medium mb2'>
        <FormattedMessage id='performance.QUESTION_ORDER' values={{order: question.order}}/>
      </div>
      <div ref={ref} className='border rounded box-shadow-1' style={{backgroundColor: isOver ? '#DFE3E6' : '#FFFFFF', opacity: isOver ? 0.5 : 1}}>
        <div className={`py2 px1 relative Question ${isDragging && 'is-dragging'}`}>
          <div className='clearfix table'>
            <div className='table-cell col-11 align-middle'>
              <TextArea
                onChange={(e) => question.text = e.target.value}
                value={question.text}
                className='pb2 pl3 full-width border-none overflow-hidden'
                placeholder={question.text}
                translatePlaceholder={false}
                style={{backgroundColor: isOver ? '#DFE3E6' : '#FFFFFF', opacity: isOver ? 0.5 : 1, transition: 'none'}}
              />
            </div>
            <div className='table-cell col-1 align-middle pr2 right-align'>
              <div className='px1 dropdown inline-block'>
                <i className='HoverAnimation-trigger--image material-symbols-solid submarine align-top' data-toggle='dropdown'>{'more_horiz'}</i>
                <ul className='dropdown-menu right-0'>
                  <li><a href='#' className='py1 px3 regular jumbo' onClick={(e) => { e.preventDefault(); onQuestionDelete(question); }}>
                    <FormattedMessage id='performance.Delete'/>
                  </a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <FormError message={errors.text} />
      </div>
    </div>
  );
});

export default Question;
